<div *ngIf="this.context && name !== 'map-view'" class="d-flex align-items-center page_header_right">
  <button *ngIf="this.context._filter == true" class="btn rounded_btn border_btn small_btn mr-3" (click)="reload()">
    <span class="filter-text mr-1">Clear Filter</span>
    <span class="material-icons cursor-pointer">close</span>
  </button>

  <i style="cursor: pointer" class="material-icons icon-left" matTooltip="Filter" [matTooltipDisabled]="showhide"
    (click)="filltertoggle()" [ngClass]="{ open: showhide }">tune</i>
</div>
 <div class="filter-section" [ngClass]="{ open: showhide }">
  <div class="filter-inner-wrapper">
    <div class="filter-header">
      <div class="d-flex justify-content-between">
        <p class="font-20 m-0">Filter</p>
        <div class="filter-iconBox">
          <span class="material-icons refresh-filter" (click)="reset()">refresh</span>
          <span class="material-icons close-filter" (click)="close()" [ngClass]="{ open: showhide }">close</span>
        </div>
      </div>
    </div>

    <div class="filter-content">
      <form [formGroup]="_form">
        <div *ngIf="name == 'loads' || name == 'all-loads'">
          <label class="label mb-2">Date Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Pick-up Date</label>
              <div class="d-flex">
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" class="input_fld"
                        placeholder="Select Date" formControlName="pickupDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt1>
                      </owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
              &nbsp;
              <label class="label mb-2">Delivery Date</label>
              <div class="d-flex">
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" class="input_fld"
                        placeholder="Select Date" formControlName="deliveryDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt2>
                      </owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;
        <div *ngIf="name == 'loads' || name == 'all-loads'">
          <label class="label mb-2">Price Range</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div class="min-max-wrap">
                <div class="min-input-box">
                  <label class="label mb-2">Min</label>
                  <div class="input_block select-border-box-outer">
                    <mat-form-field class="w-100">
                      <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                        (input)="onNumericInput('minPrice'); validatePrice()" (blur)="onNumericBlur('minPrice')"
                        class="input_fld" matInput placeholder="Min Price"
                        formControlName="minPrice" />
                    </mat-form-field>
                  </div>
                </div>
                &nbsp;
                <div class="max-input-box">
                  <label class="label mb-2">Max</label>
                  <div class="input_block select-border-box-outer">
                    <mat-form-field class="w-100">
                      <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                        (input)="onNumericInput('maxPrice'); validatePrice()" (blur)="onNumericBlur('maxPrice')"
                        class="input_fld" matInput placeholder="Max Price"
                        formControlName="maxPrice" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <p *ngIf="priceError" class="red_text">
                Max price should not be less than Min price.
              </p>
            </div>
          </div>
        </div>
        &nbsp;
        <div *ngIf="name == 'loads' || name == 'all-loads'">
          <label class="label mb-2">Trip</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Origin</label>
                <div>
                  <div class="input_block select-border-box-outer">
                    <div class="input_hover input-border">
                      <mat-form-field class="w-100" appearance="fill">
                        <input type="text" class="input_fld" matInput placeholder="Origin" formControlName="origin"
                          [matAutocomplete]="originAuto" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div> &nbsp;
              <div>
                <label class="label mb-0">Destination</label>
                <div class="input_block select-border-box-outer">
                  <div class="input_hover input-border">
                    <mat-form-field class="w-100" appearance="fill">
                      <input type="text" class="input_fld" matInput placeholder="Destination"
                        [matAutocomplete]="destinationAuto"
                        formControlName="destination" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;
        <div *ngIf="name == 'all-loads'">
          <label class="label mb-2">Status</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Status Type</label>
                <div class="input_block select-border-box-outer mb-2">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Shipment Type" class="select-border-box mt-2"
                      formControlName="shipmentStatus">
                      <mat-option value="open">Open</mat-option>
                      <mat-option value="tendered">Tendered</mat-option>
                      <mat-option value="assigned">Assigned</mat-option>
                      <mat-option value="active">Active</mat-option>
                      <mat-option value="cancelled">Cancelled</mat-option>
                      <mat-option value="completed">Completed</mat-option>
                      <mat-option value="disputed">Disputed</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="name == 'loads' || name == 'all-loads'">
          <label class="label mb-2">Equipment</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Service Type</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Service Type" class="select-border-box mt-2"
                      formControlName="loadServiceType">
                      <mat-option value="1">Full</mat-option>
                      <mat-option value="2">Partial</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              &nbsp;
              <div>
                <label class="label mb-2">Pick/Drop-off Type</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Type" class="select-border-box mt-2"
                      formControlName="pickupDropoffType">

                      <mat-option value="1">Single Stop</mat-option>
                      <mat-option value="2">Multiple Stop</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              &nbsp;
              <div>
                <label class="label mb-2">Trailer Type</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Trailer Type" class="select-border-box input_fld"
                      formControlName="trailerTypeId">

                      <mat-option *ngFor="let iTrailer of _trailerTypes" [value]="iTrailer.id">
                        {{ iTrailer.type }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              &nbsp;
              <div class="">
                <label class="label mb-2">Weight</label>
                <div class="input_hover input-border">
                  <mat-form-field class="w-100" appearance="fill">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('totalWeight')" (blur)="onNumericBlur('totalWeight')"
                      class="input_fld" matInput placeholder="Weight" formControlName="totalWeight" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="name == 'rfps'">
          <label class="label mb-2">Trip</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Origin</label>
                <div>
                  <div class="input_block select-border-box-outer">
                    <div class="input_hover input-border">
                      <mat-form-field class="w-100" appearance="fill">
                        <input type="text" class="input_fld" matInput placeholder="Origin" formControlName="origin"
                          [matAutocomplete]="originAuto" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label class="label mb-2">Destination</label>
                <div>
                  <div class="input_block select-border-box-outer">
                    <div class="input_hover input-border">
                      <mat-form-field class="w-100" appearance="fill">
                        <input type="text" class="input_fld" matInput placeholder="Destination"
                          [matAutocomplete]="destinationAuto"
                          formControlName="destination" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4" *ngIf="name == 'rfps'">
          <label class="label mb-2">Equipment</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Procedure</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Type" class="select-border-box" formControlName="procedure">
                      <mat-option value="">Select Procedure</mat-option>
                      <mat-option [value]="procedure.Live_Live">Live/Live
                      </mat-option>
                      <mat-option [value]="procedure.Live_Drop">Live/Drop
                      </mat-option>
                      <mat-option [value]="procedure.Drop_Live">Drop/Live
                      </mat-option>
                      <mat-option [value]="procedure.Drop_Drop">Drop/Drop
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div>
                <label class="label mb-2">Shipment Type</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Type" class="select-border-box" formControlName="shipmentType">
                      <!-- <mat-option>None</mat-option> -->
                      <mat-option value="1">Single</mat-option>
                      <mat-option value="2">Multiple</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4" *ngIf="name == 'rfps'">
          <label class="label mb-2">Load Details</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Duration</label>
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select Service Type" class="select-border-box" formControlName="duration">
                    <mat-option value="">Select RFP Duration</mat-option>
                    <mat-option [value]="rfpDuration.Quarterly">Quarterly
                    </mat-option>
                    <mat-option [value]="rfpDuration.Half_Yearly">Semi-annually
                    </mat-option>
                    <mat-option [value]="rfpDuration.Annually">Annually
                    </mat-option>
                    <mat-option [value]="rfpDuration.Custom">Custom
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <label class="label mb-2">Expiration Date</label>
              <div class="d-flex">
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt4" [owlDateTimeTrigger]="dt4" class="input_fld"
                        placeholder="Select Date" formControlName="expiryDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt4>
                      </owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
              &nbsp;
              <label class="label mb-2">No. of Loads</label>
              <div class="input_hover input-border">
                <mat-form-field class="w-100" appearance="fill">
                  <input type="number" (keypress)="onCheckEntry($event)" class="input_fld" matInput placeholder=" "
                    formControlName="loads" />
                </mat-form-field>
              </div>
              <label class="label mb-2">Total Volume</label>
              <div class="input_hover input-border">
                <mat-form-field class="w-100" appearance="fill">
                  <input type="number" (keypress)="onCheckEntry($event)" class="input_fld" matInput placeholder=" "
                    formControlName="volume" />
                </mat-form-field>
              </div>
              <label class="label mb-2">Weight</label>
              <div class="input_hover input-border">
                <mat-form-field class="w-100" appearance="fill">
                  <input type="number" (keypress)="onCheckEntry($event)" class="input_fld" matInput placeholder=" "
                    formControlName="weight" min="1" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="name == 'rfp-open'">
          <label class="label mb-2">RFP</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Duration</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Service Type" class="select-border-box" formControlName="duration">
                      <mat-option value="">Select RFP Duration</mat-option>
                      <mat-option [value]="rfpDuration.Quarterly">Quarterly
                      </mat-option>
                      <mat-option [value]="rfpDuration.Half_Yearly">Semi-annually
                      </mat-option>
                      <mat-option [value]="rfpDuration.Annually">Annually
                      </mat-option>
                      <mat-option [value]="rfpDuration.Custom">Custom
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <label class="label mb-2">Expiration Date</label>
                <div class="d-flex">
                  <div class="input_block">
                    <div class="input_hover input-border">
                      <div class="w-100 datepicker-wrap">
                        <input [readonly]="true" [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" class="input_fld"
                          placeholder="Select Date" formControlName="expiryDate" />
                        <mat-icon class="date-icon">today</mat-icon>
                        <owl-date-time [pickerType]="'calendar'" #dt3>
                        </owl-date-time>
                      </div>
                    </div>
                  </div>
                </div>
                &nbsp;
                <label class="label mb-2">Total Volume</label>
                <div class="input_hover input-border">
                  <mat-form-field class="w-100" appearance="fill">
                    <input type="number" (keypress)="onCheckEntry($event)" class="input_fld" placeholder="Volume" matInput
                      formControlName="volume" />
                  </mat-form-field>
                </div>
                <label class="label mb-2">Number of Loads</label>
                <div class="input_hover input-border">
                  <mat-form-field class="w-100" appearance="fill">
                    <input type="number" (keypress)="onCheckEntry($event)" placeholder="Number of Loads"  class="input_fld" matInput
                      formControlName="loads" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="name == 'admin'">
          <label class="label mb-2">Status</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">Status Type</label>
                <div class="input_block select-border-box-outer">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Status Type" class="select-border-box" formControlName="status">
                      <!-- <mat-option>None</mat-option> -->
                      <mat-option value="1">Accepted</mat-option>
                      <mat-option value="0">In Progress</mat-option>
                      <mat-option value="2">Declined</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="name == 'carrier-list'">
          <div class="form_row">
            <div class="bg-light p-3">
              <div>
                <label class="label mb-2">City</label>
                <div>
                  <div class="input_block select-border-box-outer">
                    <div class="input_hover input-border">
                      <mat-form-field class="w-100" appearance="fill">
                        <input type="text" class="input_fld" matInput placeholder="City" formControlName="city" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label class="label mb-2">State</label>
                <div>
                  <div class="input_block select-border-box-outer">
                    <div class="input_hover input-border">
                      <mat-form-field class="w-100" appearance="fill">
                        <input type="text" class="input_fld" matInput placeholder="State" formControlName="state" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label class="label mb-2">Member Since</label>
                <div class="d-flex">
                  <div class="input_block">
                    <div class="input_hover input-border">
                      <div class="w-100 datepicker-wrap">
                        <input [readonly]="true" [owlDateTime]="dt5" [owlDateTimeTrigger]="dt5" class="input_fld"
                          placeholder="Select Date" formControlName="memberSince" />
                        <mat-icon class="date-icon">today</mat-icon>
                        <owl-date-time [pickerType]="'calendar'" #dt5>
                        </owl-date-time>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label class="label mb-2 mt-3">Rating</label>
                <div class="d-flex">
                  <div class="input_block">
                    <div class="select-rating">
                      <ngx-stars initialStars="{{ _ratingScore }}" totalstars="{{ _totalstar }}" [color]="'#51af57'"
                        size="24px" [readonly]="false" (ratingOutput)="onChangeRating($event)">
                      </ngx-stars>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="name == 'user-subscription'" class="user-subscription-filter">
          <label class="label mb-2">Subscription Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Subscription Status</label>
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <mat-select placeholder="All" class="select-border-box" formControlName="status">
                    <mat-option>All</mat-option>
                    <mat-option value="active">Active</mat-option>
                    <mat-option value="expiringSoon">Expiring Soon</mat-option>
                    <mat-option value="expired">Expired</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              &nbsp;
              <label class="label mb-2">Company Type</label>
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <mat-select placeholder="All" class="select-border-box" formControlName="companyType">
                    <mat-option>All</mat-option>
                    <mat-option value="shipper">Shipper</mat-option>
                    <mat-option value="carrier">Carrier</mat-option>
                    <mat-option value="ownerOperator">Owner Operator</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              &nbsp;
              <label class="label mb-2">Subscription Plan</label>
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <mat-select placeholder="All Plans" class="select-border-box" formControlName="plan">
                    <mat-option>All Plans</mat-option>
                    <mat-option value="standard">Standard</mat-option>
                    <mat-option value="premium">Premium</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <hr />
              <label class="label mb-2">Start date and end date</label>
              <div class="d-flex">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dtSubscriptionStart" [owlDateTimeTrigger]="dtSubscriptionStart"
                        class="input_fld" placeholder="Start Date" formControlName="startDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dtSubscriptionStart></owl-date-time>
                    </div>
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dtSubscriptionEnd" [owlDateTimeTrigger]="dtSubscriptionEnd"
                        class="input_fld" placeholder="End Date" formControlName="endDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dtSubscriptionEnd></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="dateRangeError" class="text-danger mt-2 subscription-date-error">End Date cannot be before Start Date</div>
            </div>
          </div>
        </div>
        <div *ngIf="name == 'time-period'">
          <label class="label mb-2">Date Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Filter By</label>
              <div class="d-flex">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select Filter Type" formControlName="filterBy">
                    <mat-option value="volume">Volume (# of loads)</mat-option>
                    <mat-option value="spend">Total Load Revenue ($)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <hr />
              <label class="label mb-2">Time Period</label>
              <div class="d-flex">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select Time Period" formControlName="timePeriod">
                    <mat-option value="days">Last Day</mat-option>
                    <mat-option value="weeks">Last Week</mat-option>
                    <mat-option value="months">Last Month</mat-option>
                    <mat-option value="quarters">Last Quarter</mat-option>
                    <mat-option value="years">Last Year</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <hr />
              <label class="label mb-2">Custom Date Range</label>
              <div class="d-flex">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" class="input_fld"
                        placeholder="Start Date" formControlName="startDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                    </div>
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" class="input_fld"
                        placeholder="End Date" formControlName="endDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="name == 'driver-time-period'">
          <label class="label mb-2">Date Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Time Period</label>
              <div class="d-flex">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select Time Period" formControlName="timePeriod">
                    <mat-option value="days">Last Day</mat-option>
                    <mat-option value="weeks">Last Week</mat-option>
                    <mat-option value="months">Last Month</mat-option>
                    <mat-option value="quarters">Last Quarter</mat-option>
                    <mat-option value="years">Last Year</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <label class="label mb-2">Custom Date Range</label>
              <div class="d-flex mb-4">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" class="input_fld"
                        placeholder="Start Date" formControlName="customStartDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                    </div>
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" class="input_fld"
                        placeholder="End Date" formControlName="customEndDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SCHEDULED PICKUP -->
              <label class="label mb-2">Scheduled Pick-up</label>
              <div class="d-flex">
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap mb-4">
                      <input [readonly]="true" [owlDateTime]="dtScheduledPickup"
                        [owlDateTimeTrigger]="dtScheduledPickup" class="input_fld" placeholder="Select Date"
                        formControlName="scheduledPickup" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time #dtScheduledPickup [pickerType]="'calendar'"></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SCHEDULED DELIVERY -->
              <label class="label mb-2">Scheduled Delivery</label>
              <div class="d-flex">
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap mb-4">
                      <input [readonly]="true" [owlDateTime]="dtScheduledDelivery"
                        [owlDateTimeTrigger]="dtScheduledDelivery" class="input_fld" placeholder="Select Date"
                        formControlName="scheduledDelivery" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time #dtScheduledDelivery [pickerType]="'calendar'"></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ON TIME PICKUP -->
              <label class="label mb-2">On Time Pick-up</label>
              <div class="d-flex">
                <div class="input_block">
                  <mat-form-field class="w-100">
                     <div class="w-100 datepicker-wrap mb-4">
                    <mat-select placeholder="Select Status" formControlName="onTimePickup" multiple>
                      <mat-option value="On Time">On Time</mat-option>
                      <mat-option value="Late Pickup">Late Pickup</mat-option>
                    </mat-select>
                    </div>
                  </mat-form-field>
                </div>
              </div>

              <!-- ON TIME DELIVERY -->
              <label class="label mb-2">On Time Delivery</label>
              <div class="d-flex">
                <div class="input_block">
                  <mat-form-field class="w-100">
                    <div class="w-100 datepicker-wrap mb-4">
                    
                    <mat-select placeholder="Select Status" formControlName="onTimeDelivery" multiple>
                      <mat-option value="On Time">On Time</mat-option>
                      <mat-option value="Late Delivery">Late Delivery</mat-option>
                    </mat-select>
                    </div>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="name == 'carrier-driver-time-period'">
          <label class="label mb-2">Date Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Time Period</label>
              <div class="d-flex">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select Time Period" formControlName="timePeriod">
                    <mat-option value="months">Last Month</mat-option>
                    <mat-option value="quarters">Last Quarter</mat-option>
                    <mat-option value="years">Last Year</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <label class="label mb-2">Custom Date Range</label>
              <div class="d-flex">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" class="input_fld"
                        placeholder="Start Date" formControlName="customStartDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                    </div>
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" class="input_fld"
                        placeholder="End Date" formControlName="customEndDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="name === 'company-level-matrix' || name === 'financial-reporting' || name === 'accessorial-cost' || name === 'solo-accessorial-cost'">
          <label class="label mb-2">Date Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Time Period</label>
              <mat-form-field class="w-100">
                <mat-select
                  placeholder="Select Time Period"
                  formControlName="timePeriod">
                  <mat-option value="days">Last Day</mat-option>
                  <mat-option value="weeks">Last Week</mat-option>
                  <mat-option value="months">Last Month</mat-option>
                  <mat-option value="quarters">Last Quarter</mat-option>
                  <mat-option value="years">Last Year</mat-option>
                </mat-select>
              </mat-form-field>
              <hr />
              <label class="label mb-2">Custom Date Range</label>
              <div class="d-flex">
                <!-- Start Date -->
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input
                        [readonly]="true"
                        [owlDateTime]="dt1"
                        [owlDateTimeTrigger]="dt1"
                        class="input_fld"
                        placeholder="From Date"
                        formControlName="startDate" />
                      <mat-icon class="date-icon">today</mat-icon>
                      <owl-date-time
                        [pickerType]="'calendar'"
                        #dt1>
                      </owl-date-time>
                    </div>
                  </div>
                </div>
                <!-- End Date -->
                <div class="input_block">
                  <div class="input_hover input-border">

                    <div class="w-100 datepicker-wrap">

                      <input
                        [readonly]="true"
                        [owlDateTime]="dt2"
                        [owlDateTimeTrigger]="dt2"
                        class="input_fld"
                        placeholder="To Date"
                        formControlName="endDate" />

                      <mat-icon class="date-icon">today</mat-icon>

                      <owl-date-time
                        [pickerType]="'calendar'"
                        #dt2>
                      </owl-date-time>

                    </div>

                  </div>
                </div>

              </div>
              <div *ngIf="dateRangeError" class="text-danger mt-2">
                End Date cannot be earlier than Start Date.
              </div>

            </div>
          </div>
        </div>
        <div *ngIf="name === 'accessorial-cost' || name === 'solo-accessorial-cost'">
          <div class="form_row mt-3">
            <div class="bg-light p-3">

              <label class="label mb-2">Shipper Name</label>
              <div class="input_block mb-3">
                <div class="input_hover input-border">
                  <input class="input_fld" placeholder="Search by shipper name" formControlName="shipperName" />
                </div>
              </div>

              <ng-container *ngIf="name === 'accessorial-cost'">
                <label class="label mb-2">Driver Name</label>
                <div class="input_block mb-3">
                  <div class="input_hover input-border">
                    <input class="input_fld" placeholder="Search by driver name" formControlName="driverName" />
                  </div>
                </div>
              </ng-container>

              <label class="label mb-2">Truck Number</label>
              <div class="input_block mb-3">
                <div class="input_hover input-border">
                  <input class="input_fld" placeholder="Search by truck number" formControlName="truckNumber" />
                </div>
              </div>

              <label class="label mb-2">Amount Range ($)</label>
              <div class="d-flex mb-3">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <input class="input_fld" type="text" inputmode="decimal" placeholder="Min Amount"
                      formControlName="minAmount" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('minAmount')" (blur)="onNumericBlur('minAmount')" />
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <input class="input_fld" type="text" inputmode="decimal" placeholder="Max Amount"
                      formControlName="maxAmount" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('maxAmount')" (blur)="onNumericBlur('maxAmount')" />
                  </div>
                </div>
              </div>

              <label class="label mb-2">Charge Type</label>
              <mat-form-field class="w-100 mb-2">
                <mat-select placeholder="Select Charge Type" formControlName="costType">
                  <mat-option value="1">Detention</mat-option>
                  <mat-option value="2">Layover</mat-option>
                  <mat-option value="3">Lumper</mat-option>
                </mat-select>
              </mat-form-field>

              <label class="label mb-2">Status</label>
              <mat-form-field class="w-100">
                <mat-select placeholder="Select Status" formControlName="status">
                  <mat-option value="0">Pending</mat-option>
                  <mat-option value="1">Approved</mat-option>
                  <mat-option value="2">Declined</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </div>
        </div>


        <div *ngIf="name === 'map-view'">
          <label class="label mb-2">LYNK ID</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div class="input_block select-border-box-outer">
                <div class="input_hover input-border">
                  <mat-form-field class="w-100" appearance="fill">
                    <input type="text" autocomplete="off" class="input_fld" matInput
                      placeholder="Enter LYNK ID" formControlName="lynkId" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <label class="label mb-2 mt-3">Trip</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Origin</label>
              <div class="input_block select-border-box-outer">
                <div class="input_hover input-border">
                  <mat-form-field class="w-100" appearance="fill">
                    <input type="text" class="input_fld" matInput placeholder="Enter Origin Location"
                      formControlName="origin" [matAutocomplete]="originAuto"
                      (focus)="initMapViewPlacesAutocomplete()" />
                  </mat-form-field>
                </div>
              </div>
               <label class="label mb-2 mt-3">Destination</label>
              <div class="input_block select-border-box-outer">
                <div class="input_hover input-border">
                  <mat-form-field class="w-100" appearance="fill">
                    <input type="text" class="input_fld" matInput placeholder="Enter Destination Location"
                      formControlName="destination" [matAutocomplete]="destinationAuto"
                      (focus)="initMapViewPlacesAutocomplete()" />
                  </mat-form-field>
                </div>
              </div>
              <label class="label mb-2 mt-3">Radius</label>
              <div class="d-flex align-items-end">
                <div class="input_block select-border-box-outer mr-2">
                  <div class="input_hover input-border">
                    <mat-form-field class="w-100" appearance="fill">
                      <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                        (input)="onNumericInput('radius', 0)" class="input_fld" matInput placeholder="Enter Radius"
                        formControlName="radius" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="input_block select-border-box-outer radius-unit-input">
                  <mat-form-field class="w-100">
                    <mat-select placeholder="Select Unit" class="select-border-box" formControlName="radiusUnit">
                      <mat-option value="miles">Miles</mat-option>
                      <mat-option value="kilometers">Kilometers</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <label class="label mb-2 mt-3">Pickup Date</label>
              <div class="input_block">
                <div class="input_hover input-border">
                  <div class="w-100 datepicker-wrap">
                    <input [readonly]="true" [owlDateTime]="mvdt1" [owlDateTimeTrigger]="mvdt1" class="input_fld"
                      placeholder="Select Pickup Date" formControlName="pickupDate" />
                    <mat-icon fontSet="material-symbols-outlined" class="date-icon">calendar_month</mat-icon>
                    <owl-date-time [pickerType]="'calendar'" #mvdt1></owl-date-time>
                  </div>
                </div>
              </div>
              <label class="label mb-2 mt-3">Delivery Date</label>
              <div class="input_block">
                <div class="input_hover input-border">
                  <div class="w-100 datepicker-wrap">
                    <input [readonly]="true" [owlDateTime]="mvdt2" [owlDateTimeTrigger]="mvdt2" class="input_fld"
                      placeholder="Select Delivery Date" formControlName="deliveryDate" />
                    <mat-icon fontSet="material-symbols-outlined" class="date-icon">calendar_month</mat-icon>
                    <owl-date-time [pickerType]="'calendar'" #mvdt2></owl-date-time>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <label class="label mb-2 mt-3">Load Owners</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">User Type</label>
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select User Type" class="select-border-box" formControlName="userType"
                    (selectionChange)="onMapViewUserTypeChange()">
                    <mat-option>None</mat-option>
                    <mat-option value="2">Shipper</mat-option>
                    <mat-option value="3">Carrier</mat-option>
                    <mat-option value="5">Owner Operator</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <label class="label mb-2 mt-3">User Name</label>
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <input type="text" class="input_fld" matInput placeholder="Search User Name"
                    formControlName="userName" [matAutocomplete]="mvUserAuto" />
                </mat-form-field>
                <mat-autocomplete #mvUserAuto="matAutocomplete" (optionSelected)="onMapViewUserSelected($event)">
                  <mat-option *ngFor="let user of mapViewFilteredUsers" [value]="user">
                    {{ user.name }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>

          <label class="label mb-2 mt-3">Load Status</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <div class="input_block select-border-box-outer">
                <mat-form-field class="w-100">
                  <mat-select placeholder="Select Status" class="select-border-box" formControlName="statusType">
                    <mat-option value="open">Open</mat-option>
                    <mat-option value="tendered">Tendered</mat-option>
                    <mat-option value="assigned">Assigned</mat-option>
                    <mat-option value="active">Active</mat-option>
                    <mat-option value="disputed">Disputed</mat-option>
                    <mat-option value="completed">Completed</mat-option>
                    <mat-option value="cancelled">Cancelled</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <label class="label mb-2 mt-3">Advanced Filters</label>
          <div class="form_row">
            <div class="bg-light p-3">
              <label class="label mb-2">Revenue Range ($)</label>
              <div class="min-max-wrap">
                <div class="min-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('minPrice'); validatePrice()" (blur)="onNumericBlur('minPrice')"
                      class="input_fld" matInput placeholder="Min Revenue" formControlName="minPrice" />
                  </mat-form-field>
                </div>
                <div class="max-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('maxPrice'); validatePrice()" (blur)="onNumericBlur('maxPrice')"
                      class="input_fld" matInput placeholder="Max Revenue" formControlName="maxPrice" />
                  </mat-form-field>
                </div>
              </div>
              <p *ngIf="priceError" class="red_text">
                Max revenue should not be less than Min revenue.
              </p>

              <label class="label mb-2 mt-3">Revenue / Mile ($)</label>
              <div class="min-max-wrap">
                <div class="min-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('minRevenuePerMile')" (blur)="onNumericBlur('minRevenuePerMile')"
                      class="input_fld" matInput placeholder="Min Revenue / Mile" formControlName="minRevenuePerMile" />
                  </mat-form-field>
                </div>
                <div class="max-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('maxRevenuePerMile')" (blur)="onNumericBlur('maxRevenuePerMile')"
                      class="input_fld" matInput placeholder="Max Revenue / Mile" formControlName="maxRevenuePerMile" />
                  </mat-form-field>
                </div>
              </div>

              <label class="label mb-2 mt-3">Miles Range</label>
              <div class="min-max-wrap">
                <div class="min-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('minMiles', 0)" (blur)="onNumericBlur('minMiles', 0)"
                      class="input_fld" matInput placeholder="Min Miles" formControlName="minMiles" />
                  </mat-form-field>
                </div>
                <div class="max-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('maxMiles', 0)" (blur)="onNumericBlur('maxMiles', 0)"
                      class="input_fld" matInput placeholder="Max Miles" formControlName="maxMiles" />
                  </mat-form-field>
                </div>
              </div>

              <label class="label mb-2 mt-3">Weight</label>
              <div class="min-max-wrap">
                <div class="min-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('minWeight', 0)" (blur)="onNumericBlur('minWeight', 0)"
                      class="input_fld" matInput placeholder="Min Weight" formControlName="minWeight" />
                  </mat-form-field>
                </div>
                <div class="max-input-box">
                  <mat-form-field class="w-100">
                    <input type="text" inputmode="decimal" (keypress)="onCheckEntry($event)"
                      (input)="onNumericInput('maxWeight', 0)" (blur)="onNumericBlur('maxWeight', 0)"
                      class="input_fld" matInput placeholder="Max Weight" formControlName="maxWeight" />
                  </mat-form-field>
                </div>
              </div>

              <label class="label mb-2 mt-3">Pickup Date Range</label>
              <div class="d-flex">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="mdt3" [owlDateTimeTrigger]="mdt3" class="input_fld"
                        placeholder="From Date" formControlName="pickupDateFrom" />
                      <mat-icon fontSet="material-symbols-outlined" class="date-icon">calendar_month</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #mdt3></owl-date-time>
                    </div>
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="mdt4" [owlDateTimeTrigger]="mdt4" class="input_fld"
                        placeholder="To Date" formControlName="pickupDateTo" />
                      <mat-icon fontSet="material-symbols-outlined" class="date-icon">calendar_month</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #mdt4></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>

              <label class="label mb-2 mt-3">Delivery Date Range</label>
              <div class="d-flex">
                <div class="input_block mr-2">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="mdt5" [owlDateTimeTrigger]="mdt5" class="input_fld"
                        placeholder="From Date" formControlName="deliveryDateFrom" />
                      <mat-icon fontSet="material-symbols-outlined" class="date-icon">calendar_month</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #mdt5></owl-date-time>
                    </div>
                  </div>
                </div>
                <div class="input_block">
                  <div class="input_hover input-border">
                    <div class="w-100 datepicker-wrap">
                      <input [readonly]="true" [owlDateTime]="mdt6" [owlDateTimeTrigger]="mdt6" class="input_fld"
                        placeholder="To Date" formControlName="deliveryDateTo" />
                      <mat-icon fontSet="material-symbols-outlined" class="date-icon">calendar_month</mat-icon>
                      <owl-date-time [pickerType]="'calendar'" #mdt6></owl-date-time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <button class="btn cancel_btn small_btn mr-2" (click)="close()">
            Cancel
          </button>
          <button class="rounded_btn green_btn small_btn btn btn_shadow" (click)="applyFilter()"> Apply Filter
          </button>
        </div>
        <mat-autocomplete #originAuto="matAutocomplete" (optionSelected)="onOriginSuggestionSelected($event)">
          <mat-option *ngFor="let item of filteredOriginSuggestions" [value]="item">
            {{ item }}
          </mat-option>
        </mat-autocomplete>

        <mat-autocomplete #destinationAuto="matAutocomplete" (optionSelected)="onDestinationSuggestionSelected($event)">
          <mat-option *ngFor="let item of filteredDestinationSuggestions" [value]="item">
            {{ item }}
          </mat-option>
        </mat-autocomplete>
      </form>
    </div>
  </div>
</div>